<template>
    <div class="container-fluid text-white py-5 shadow-lg position-relative d-flex align-items-center hero-section"
        :style="loading ? 'background: #121212' : obtenerFondo()">

        <div class="container py-lg-5">
            <div class="row align-items-center">

                <div class="col-lg-8 mb-5 mb-lg-0">
                    <div class="category-content-wrapper">
                        <div v-if="loading" class="skeleton-container">
                            <div class="skeleton sk-tag mb-3"></div>
                            <div class="skeleton sk-title mb-2"></div>
                            <div class="skeleton sk-subtitle mb-4"></div>
                            <div class="row g-3">
                                <div v-for="i in 4" :key="i" class="col-md-6">
                                    <div class="skeleton sk-line"></div>
                                </div>
                            </div>
                            <div class="skeleton sk-btn mt-5"></div>
                        </div>

                        <transition v-else name="fade-content" mode="out-in">
                            <div :key="categoriaActual.slug" class="content-body">
                                <h6 class="text-warning text-uppercase fw-bold ls-2 mb-3">
                                    Categoría: {{ categoriaActual.nombre }}
                                </h6>

                                <h1 class="display-3 fw-bold mb-4 main-title">
                                    {{ categoriaActual.titulo }}<br>
                                    <span class="text-info-gradient"> {{ categoriaActual.subtitulo }}</span>
                                </h1>

                                <div class="row category-benefits-list">
                                    <div class="col-12">
                                        <ul class="list-unstyled row g-3">
                                            <li v-for="item in categoriaActual.lineas || []" :key="item.id"
                                                class="col-md-6 d-flex align-items-center mb-1 benefit-item">
                                                <i class="bx bxs-check-circle text-warning me-2 fs-5"></i>
                                                <span class="fs-5">{{ item.nombre }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="action-area">
                                    <router-link
                                        :to="{ name: 'Busquedaspordiagrama', query: { cat: categoriaActual.slug } }"
                                        class="btn btn-warning btn-lg px-5 py-3 mt-4 fw-bold rounded-pill shadow-lg hover-grow">
                                        EXPLORAR TODO {{ categoriaActual.nombre }}
                                    </router-link>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="mini-cards-container">
                        <div v-for="cat in (loading ? 4 : categorias)" :key="loading ? cat : cat.slug"
                            @click="!loading && cambiarCategoria(cat.slug)" class="mini-card p-1"
                            :class="{ 'active-mini': !loading && categoriaActiva === cat.slug, 'pointer': !loading }">

                            <div class="d-flex align-items-center bg-dark-transparent p-2 rounded-3 h-100">
                                <div v-if="loading" class="skeleton sk-img rounded-2 me-3"></div>
                                <img v-else :src="cat.imagen" class="img-mini rounded-2 me-3" alt="thumb">

                                <div class="flex-grow-1">
                                    <div v-if="loading">
                                        <div class="skeleton sk-text-sm mb-1" style="width: 70%;"></div>
                                    </div>
                                    <template v-else>
                                        <p class="small mb-0 fw-bold text-uppercase text-truncate">{{ cat.nombre }}</p>
                                        <p class="x-small mb-0 opacity-75">Ver detalles <i
                                                class="bx bx-right-arrow-alt"></i></p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            categoriaActiva: null,
            categorias: [],
            timer: null,
            // Nueva variable para la imagen que realmente se está viendo
            imagenVisual: '',
            loading: true
        };
    },

    computed: {
        categoriaActual() {
            return this.categorias.find(c => c.slug === this.categoriaActiva) || {};
        }
    },

    watch: {
        // Cada vez que cambia la categoría, pre-cargamos la imagen
        'categoriaActual.imagen': {
            immediate: true,
            handler(nuevaUrl) {
                if (nuevaUrl) {
                    this.prepararTransicionImagen(nuevaUrl);
                }
            }
        }
    },

    methods: {
        async cargarCategorias() {
            try {
                this.loading = true;
                const { data } = await axios.get('/api/categoryHomme');
                this.categorias = data;

                if (this.categorias.length) {
                    this.categoriaActiva = this.categorias[0].slug;
                    this.loading = false;
                }
            } catch (error) {
                console.error('Error cargando categorías', error);
                this.loading = false;
            }
        },

        prepararTransicionImagen(url) {
            const img = new Image();
            img.src = url;
            img.onload = () => {
                // Solo cambiamos la URL visual cuando el navegador confirma que ya la bajó
                this.imagenVisual = url;
            };
        },

        obtenerFondo() {
            // Usamos la imagenVisual que garantiza que ya está cargada
            const urlFinal = this.imagenVisual || this.categoriaActual.imagen;

            return {
                backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.9) 30%, rgba(0,0,0,0.2) 100%), url(${urlFinal})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                // Mantenemos la transición suave de 1 segundo
                transition: 'background-image 1s ease-in-out'
            };
        },

        cambiarCategoria(slug) {
            this.categoriaActiva = slug;
            this.reiniciarIntervalo();
        },

        siguiente() {
            if (!this.categorias.length) return;
            const index = this.categorias.findIndex(c => c.slug === this.categoriaActiva);
            const siguienteIndex = (index + 1) % this.categorias.length;
            this.categoriaActiva = this.categorias[siguienteIndex].slug;
        },

        reiniciarIntervalo() {
            if (this.timer) clearInterval(this.timer);
            this.startTimer();
        },

        startTimer() {
            this.timer = setInterval(() => {
                this.siguiente();
            }, 5000);
        }
    },

    async mounted() {
        await this.cargarCategorias();
        this.startTimer();
    },

    beforeUnmount() {
        if (this.timer) clearInterval(this.timer);
    }
}
</script>
<style scoped>
/* Contenedor Principal con altura dinámica */
.hero-section {
    min-height: 100vh;
    /* Ocupa toda la pantalla si es necesario */
    background-size: cover !important;
    background-position: center !important;
    transition: background 0.8s ease-in-out;
}

.pointer {
    cursor: pointer;
}

/* Wrapper de contenido con mejor control de altura */
.category-content-wrapper {
    min-height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.main-title {
    text-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    line-height: 1.1;
}

.text-info-gradient {
    color: #0dcaf0;
    background: linear-gradient(90deg, #0dcaf0, #00d4ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Lista de beneficios fija para evitar saltos del botón */
.category-benefits-list {
    min-height: 120px;
    margin-bottom: 20px;
}

.benefit-item {
    transition: transform 0.2s ease;
}

/* --- RESPONSIVIDAD DE MINI CARDS --- */
.mini-cards-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* En tablets/móviles, las cards se vuelven horizontales con scroll */
@media (max-width: 991.98px) {
    .mini-cards-container {
        flex-direction: row;
        overflow-x: auto;
        padding-bottom: 15px;
        scrollbar-width: none;
        /* Firefox */
    }

    .mini-cards-container::-webkit-scrollbar {
        display: none;
    }

    /* Chrome/Safari */

    .mini-card {
        flex: 0 0 200px;
        /* Tamaño fijo en horizontal */
    }

    .hero-section {
        min-height: auto;
        padding-top: 80px !important;
    }
}

.mini-card {
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    border: 2px solid transparent;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.03);
}

.img-mini {
    width: 70px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
    opacity: 0.5;
    transition: all 0.3s ease;
}

.active-mini {
    border-color: #ffc107;
    background: rgba(255, 193, 7, 0.1) !important;
    transform: translateX(-10px);
    /* Efecto de "salida" hacia la izquierda en desktop */
}

@media (max-width: 991.98px) {
    .active-mini {
        transform: translateY(-5px);
    }
}

.active-mini .img-mini {
    opacity: 1;
    transform: scale(1.1);
}

.bg-dark-transparent {
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
}

/* Animaciones de entrada/salida */
.fade-content-enter-active,
.fade-content-leave-active {
    transition: all 0.5s ease;
}

.fade-content-enter-from {
    opacity: 0;
    transform: translateY(20px);
}

.fade-content-leave-to {
    opacity: 0;
    transform: translateY(-20px);
}

/* SKELETONS */
.sk-tag {
    width: 150px;
    height: 20px;
}

.sk-title {
    width: 80%;
    height: 60px;
}

.sk-subtitle {
    width: 60%;
    height: 60px;
}

.sk-line {
    height: 25px;
    width: 100%;
}

.sk-btn {
    width: 250px;
    height: 55px;
    border-radius: 30px;
}

.sk-img {
    width: 70px;
    height: 50px;
    flex-shrink: 0;
}
</style>